export enum CopyButtonType {
    TEXT = 'text',
    PASSWORD = 'password',
    TOTP = 'totp',
    PAYMENT_CARD_NUMBER = 'paymentCardNumber',
    CVV_CODE = 'cvvCode',
    SECURE_TEXT_AREA = 'secureTextArea',
}
